/* eslint-disable */
import { v4 as uuidv4 } from "uuid";
import {
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	TextField,
	Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { getCristales } from "../../../project/services/ArticuloService";
import { getCacheData } from "../../services/CacheService";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import { formatEsferaCilindroAdicion } from "../../utils/utils";

const initialSearchData = {
	descripcion: "",
	marca: "",
	material: "",
	precioVentaDesde: "",
	precioVentaHasta: "",
	disponibleObraSocial: "T",
};

const disponibleObraSocial = [
	{
		id: "T",
		descripcion: "Todos",
	},
	{
		id: "S",
		descripcion: "Sí",
	},
	{
		id: "N",
		descripcion: "No",
	},
];
//
// ################################################################################
//
const BuscarCristalDialog = ({
	open,
	onClose,
	onSelect,
	anteojoCristalesTipoAnteojo,
	esfera,
	cilindro,
	adicion,
	ojo,
}) => {
	const [searchData, setSearchData] = useState({
		...initialSearchData,
		anteojoCristalesTipoAnteojo,
		esfera,
		cilindro,
		adicion,
	});
	const [articulos, setArticulos] = useState([]);
	const [isDoingSomething, setIsDoingSomething] = useState(false);
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);
	const [totalRowsCount, setTotalRowsCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [blCrMateriales, setBlCrMateriales] = useState([]);
	const [blCrMarcas, setBlCrMarcas] = useState([]);

	const tableColumns = [
		{
			field: "descripcion_cristal_producto",
			headerName: "Producto",
			headerAlign: "center",
			align: "left",
			flex: 5,
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.descripcion_cristal_producto;
				_val = _val ? _val.toUpperCase() : "";
				return _val;
			},
		},
		{
			field: "adicion",
			headerName: "Adición",
			headerAlign: "center",
			align: "center",
			flex: 1,
			type: "number",
			sortable: false,
			renderCell: (params) => {
				let _val = formatEsferaCilindroAdicion(params.row.adicion);
				_val = _val ? _val : "";
				return _val;
			},
		},
		{
			field: "valor_bl_cr_diametro",
			headerName: "Diámetro",
			headerAlign: "center",
			align: "center",
			flex: 1,
			type: "number",
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.valor_bl_cr_diametro;
				_val = _val ? _val : "";
				return _val;
			},
		},
		{
			field: "tiempo_entrega",
			headerName: "Tpo Entrega (d)",
			headerAlign: "center",
			align: "center",
			flex: 1,
			type: "number",
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.tiempo_entrega;
				_val = _val ? _val : "";
				return _val;
			},
		},
		{
			field: "precio_venta_lista",
			headerName: "Prc Venta",
			headerAlign: "center",
			align: "right",
			flex: 1,
			type: "number",
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.precio_venta_lista.toFixed(2);
				_val = _val ? _val : "";
				return _val;
			},
		},
		{
			field: "actions",
			headerName: "Seleccionar",
			headerAlign: "center",
			align: "left",
			flex: 1,
			sortable: false,
			filterable: false,
			renderCell: (params) => (
				<>
					{params.row.cu !== "view" && (
						<Tooltip title="seleccionar">
							<IconButton
								size="small"
								aria-label="update"
								onClick={() => handleRowClick(params.row)}
							>
								<CheckIcon />
							</IconButton>
						</Tooltip>
					)}
				</>
			),
		},
	];

	const tableOptions = {
		disableRowSelectionOnClick: true,
		disableColumnMenu: true,
		disableColumnFilter: true,
		disableColumnSelector: true,
		disableDensitySelector: true,
		hideFooter: true,
		localeText: {
			noRowsLabel: "",
			noResultsOverlayLabel: "",
		},
		sx: {
			"& .MuiDataGrid-cell": {
				fontSize: "0.9em",
			},
			"& .MuiDataGrid-columnHeaders": {
				backgroundColor: "#f5f5f5",
			},
		},
	};
	//
	// ################################################################################
	//
	useEffect(() => {
		loadBlCrMateriales();
		loadBlCrMarcas();
	}, []);
	//
	// ################################################################################
	//
	useEffect(() => {
		load();
	}, [currentPage, rowsPerPage]);
	//
	// ################################################################################
	//
	const loadBlCrMateriales = async () => {
		const response = await getCacheData("bl_cr_material")
		if (response.ok) {
			setBlCrMateriales(response.data.data);
		} else {
			setBlCrMateriales([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadBlCrMarcas = async () => {
		const response = await getCacheData("bl_cr_marca")
		if (response.ok) {
			setBlCrMarcas(response.data.data);
		} else {
			setBlCrMarcas([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const handleChange = (e) => {
		setSearchData({
			...searchData,
			[e.target.name]: e.target.value,
		});
	};
	//
	// ################################################################################
	//
	const handleLimpiar = () => {
		setSearchData({
			...initialSearchData,
			anteojoCristalesTipoAnteojo,
			esfera,
			cilindro,
			adicion,
		});
	};
	//
	// ################################################################################
	//
	const handleBuscar = () => {
		load();
	};
	//
	// ################################################################################
	//
	const load = async () => {
		let _params = {
			anteojoCristalesTipoAnteojo: anteojoCristalesTipoAnteojo,
			esfera: esfera,
			cilindro: cilindro,
			adicion: adicion,
			descripcion: searchData.descripcion,
			marca: searchData.marca,
			material: searchData.material,
			precioVentaDesde: searchData.precioVentaDesde,
			precioVentaHasta: searchData.precioVentaHasta,
			disponibleObraSocial: searchData.disponibleObraSocial,
			rows: rowsPerPage,
			first: currentPage * rowsPerPage,
		};

		setIsDoingSomething(true);
		const response = await getCristales(_params);
		setIsDoingSomething(false);

		if (response.ok) {
			let _articulosTmp = response.data.data;
			_articulosTmp.forEach((item) => {
				item.id = uuidv4();
			});

			setTotalRowsCount(response.data.count);
			setArticulos(_articulosTmp);
		} else {
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const handleRowClick = (parRow) => {
		onSelect(parRow);
	};
	//
	// ################################################################################
	//
	const handleCloseDialog = () => {
		onClose();
	};
	//
	// ################################################################################
	//
	return (
		<>
			<Dialog
				open={open}
				onClose={handleCloseDialog}
				maxWidth="xl"
				fullWidth={true}
				scroll="paper"
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Búsqueda de Cristal para ojo {ojo === "OD" ? "derecho" : "izquierdo"}{" "}
					de tipo de anteojo {anteojoCristalesTipoAnteojo}
					<IconButton
						aria-label="close"
						onClick={onClose}
						sx={{
							position: "absolute",
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				<DialogContent dividers>
					<Box>
						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12} md={4}>
								{/* Descripcion */}

								<TextField
									sx={{ width: "100%" }}
									variant="outlined"
									size="small"
									name="descripcion"
									label="Descripción"
									value={searchData.descripcion}
									onChange={handleChange}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Marca */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="bl-cr-marca-select-label">Marca</InputLabel>
									<Select
										labelId="marca-select-label"
										id="marca-select"
										name="marca"
										value={searchData.marca}
										label="Marca"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{blCrMarcas.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>

							<Grid item xs={12} md={4}>
								{/* Material */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="material-select-label">Material</InputLabel>
									<Select
										labelId="material-select-label"
										id="material-select"
										name="material"
										value={searchData.material}
										label="material"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{blCrMateriales.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
						</Grid>

						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12} md={4}>
								{/* disponible para obra social */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="disponible-os-select-label">
										Disponible para Obras Sociales
									</InputLabel>
									<Select
										labelId="disponible-os-select-label"
										id="disponible-os-select"
										name="disponibleObraSocial"
										value={searchData.disponibleObraSocial}
										label="Disponible para Obras Sociales"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{disponibleObraSocial.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Precio de venta desde */}

								<TextField
									sx={{ width: "100%" }}
									id="precio-venta-desde"
									size="small"
									name="precioVentaDesde"
									label="Desde precio"
									value={searchData.precioVentaDesde}
									onChange={handleChange}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Precio de venta hasta */}
								<TextField
									sx={{ width: "100%" }}
									id="precio-venta-hasta"
									size="small"
									name="precioVentaHasta"
									label="Hasta precio"
									value={searchData.precioVentaHasta}
									onChange={handleChange}
								/>
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ mb: 1, float: "right" }}>
						<Button sx={{ mr: 1 }} variant="contained" onClick={handleBuscar}>
							Buscar
						</Button>
						<Button sx={{ mr: 1 }} variant="outlined" onClick={handleLimpiar}>
							Limpiar
						</Button>
					</Box>

					<Paper
						sx={{
							width: "100%",
							overflow: "hidden",
							border: "1px solid LightGrey",
						}}
					>
						<DataGrid
							rows={articulos}
							columns={tableColumns}
							{...tableOptions}
						/>
					</Paper>
				</DialogContent>
			</Dialog>

			{/* >>>> Messages */}

			{showMessage && (
				<Message
					showMessage={showMessage}
					setShowMessage={setShowMessage}
					message={message}
				/>
			)}

			<WaitingDialog open={isDoingSomething} />
		</>
	);
};
export default BuscarCristalDialog;
